export default {
  'me.title': 'ข้อมูลสมาชิก',
  'me.line_id': 'LINE ID',
  'me.member_card_number': 'หมายเลขบัตรสมาชิก',
  'me.education_background': 'วุฒิการศึกษา',
  'me.habit': 'ความสนใจและงานอดิเรก',
  'me.register_full': 'ลงทะเบียนเป็นสมาชิกเรียบร้อยแล้ว',
  'me.modify': 'แก้ไขข้อมูลสมาชิก',
} as Record<string, string>;
